/**
 * Traffic News Dictionary
 * 
 * 運輸署字典
 * 特別交通消息
 */

const common = {
  title: {
    tc_name: '特別交通消息',
    en_name: 'Special Traffic News',
  },
  noNews: {
    tc_name: '暫無特別交通消息',
    en_name: 'No Special Traffic News',
  },
  error: {
    tc_name: '無法載入資料',
    en_name: 'Failed to Load Data',
  },
  lastUpdate: {
    tc_name: '最後更新',
    en_name: 'Last Update',
  },
  viewDetails: {
    tc_name: '查看詳情',
    en_name: 'View Details',
  },
  refreshInterval: {
    tc_name: '每15分鐘更新',
    en_name: 'Updated every 15 minutes',
  },
  location: {
    tc_name: '位置',
    en_name: 'Location',
  },
  description: {
    tc_name: '描述',
    en_name: 'Description',
  },
  startTime: {
    tc_name: '開始時間',
    en_name: 'Start Time',
  },
  endTime: {
    tc_name: '結束時間',
    en_name: 'End Time',
  },
};

// 消息類型映射
const messageTypes = {
  'accident': {
    tc_name: '交通意外',
    en_name: 'Traffic Accident',
    icon: '🚨',
    color: '#f44336',
  },
  'roadwork': {
    tc_name: '道路工程',
    en_name: 'Road Work',
    icon: '🚧',
    color: '#ff9800',
  },
  'closure': {
    tc_name: '道路封閉',
    en_name: 'Road Closure',
    icon: '🚫',
    color: '#f44336',
  },
  'congestion': {
    tc_name: '交通擠塞',
    en_name: 'Traffic Congestion',
    icon: '⚠️',
    color: '#ff9800',
  },
  'other': {
    tc_name: '其他',
    en_name: 'Other',
    icon: 'ℹ️',
    color: '#2196f3',
  },
};

const TrafficNews_Dict = {
  common,
  messageTypes,
};

export default TrafficNews_Dict;

